import { Fragment, h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { when } from "mobx";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import CartProducts from "./CartProducts";
import CartPromotions from "./CartPromotions";
import FulfillmentMethodForm from "../../components/FulfillmentMethodForm";
import FulfillmentTimeForm from "../../components/FulfillmentTimeForm";
import CartSummaryRows from "./CartSummaryRows";
import Alert from "../../components/Alert";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import CrossSellingList from "../../components/CrossSellingList";
import { FulfillmentSettingsTracking, Tracking, } from "restaumatic-client";
function CartBody(props) {
    var _a, _b, _c;
    const { cart, isCartOpen, onChangeRestaurant } = props;
    const { fulfillmentFormController, fulfillmentTime } = cart;
    const trackingEventHasBeenSent = useRef(false);
    const crossSellingItems = cart.crossSellingCreator.items.raw;
    const isImageVisible = Boolean(Number(window.Skubacz.configuration.theme_settings.cart_dish_images));
    const imageType = window.Skubacz.configuration.theme_settings.dish_image_style ===
        "rounded-circle"
        ? "circle"
        : "square";
    useEffect(() => {
        return when(() => cart.error.type == "NotOverlappingDishes", () => {
            Tracking.trackEvent({
                tag: "NotOverlappingDishes",
                contents: {
                    action: "not_overlapping_delivery_times_message",
                    category: "cart",
                    label: cart.restaurantName,
                },
            });
        });
    }, []);
    const handleTimeChange = () => {
        if (isCartOpen && fulfillmentTime.isEditable) {
            fulfillmentTime.save();
            if (!trackingEventHasBeenSent.current) {
                FulfillmentSettingsTracking.chooseDateEvent({ tag: "Cart" });
                trackingEventHasBeenSent.current = true;
            }
        }
    };
    return (h(Fragment, null,
        h(Alert, { type: (_a = cart.orderingHoursMessage) === null || _a === void 0 ? void 0 : _a.level, message: (_b = cart.orderingHoursMessage) === null || _b === void 0 ? void 0 : _b.message, fieldId: "cart.error" }),
        h("div", { class: "u-childs-separator" },
            h(CartProducts, { mode: "editable", items: cart.orderLines, isImageVisible: isImageVisible, imageType: imageType }),
            h(CartPromotions, { fodState: cart.fodState, fodController: cart.fodFormController, promotions: cart.promotions, couponState: cart.couponState, cartMeetsCouponPromotionConditions: cart.cartMeetsCouponPromotionConditions }),
            fulfillmentFormController.isFulfillmentEditable &&
                cart.orderDetails.isFulfillmentEditable && (h(CartFulfillmentSettings, { fulfillmentFormController: fulfillmentFormController, fulfillmentMethodsOptions: cart.fulfillmentMethodsOptions, fulfillmentTime: fulfillmentTime, orderDetails: cart.orderDetails, geolocation: cart.geolocation, onTimeChange: handleTimeChange, onChangeRestaurant: onChangeRestaurant }))),
        h(Alert, { type: cart.error.level, message: (_c = cart.error) === null || _c === void 0 ? void 0 : _c.message, fieldId: "cart.error" }),
        h(AvailabilityDebugInfo, { name: "Cart", fieldId: "cart", availability: cart.availability }),
        h(CartSummaryRows, { deliveryPrice: cart.deliveryPrice, packagingPrice: cart.packagingPrice }),
        crossSellingItems.length > 0 && (h(CrossSellingList, { fieldId: "cart.crossSelling", items: crossSellingItems }))));
}
// TODO: DRY with Checkout.tsx
const CartFulfillmentSettings = observer((props) => {
    const { fulfillmentFormController, fulfillmentMethodsOptions, fulfillmentTime, orderDetails, geolocation, onTimeChange, onChangeRestaurant, } = props;
    return (h("form", { class: "delivery is-editing" },
        h("h5", null, translate(t.orders.form.fulfillment_options)),
        fulfillmentTime.isEditable && (h(FulfillmentTimeForm, { fulfillmentTime: fulfillmentTime, controller: fulfillmentFormController.fulfillmentTimeController, onChange: onTimeChange })),
        h(FulfillmentMethodForm, { orderDetails: orderDetails, geolocation: geolocation, options: fulfillmentMethodsOptions, controller: fulfillmentFormController.fulfillmentMethodController, withApartmentInfo: false, withHiddenNoContactDelivery: false, onChangeRestaurant: onChangeRestaurant })));
});
export default observer(CartBody);
